export const BLUE_PRINT_REGISTRIES_RESET_STATE = 'BLUE_PRINT_REGISTRIES_RESET_STATE';
export const BLUE_PRINT_REGISTRIES_CURRENT_ITEM = 'BLUE_PRINT_REGISTRIES_CURRENT_ITEM';

export const BLUE_PRINT_REGISTRIES_REQUEST_LOADING = 'BLUE_PRINT_REGISTRIES_REQUEST_LOADING';
export const BLUE_PRINT_REGISTRIES_REQUEST_SUCCESS = 'BLUE_PRINT_REGISTRIES_REQUEST_SUCCESS';
export const BLUE_PRINT_REGISTRIES_REQUEST_FAILED = 'BLUE_PRINT_REGISTRIES_REQUEST_FAILED';

export const BLUE_PRINT_REGISTRIES_CURRENT_ACTION = 'BLUE_PRINT_REGISTRIES_CURRENT_ACTION';
export const BLUE_PRINT_REGISTRIES_RESET_ACTION = 'BLUE_PRINT_REGISTRIES_RESET_ACTION';